export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.611 3.611a5.5 5.5 0 11.772 8.419l-2.97 2.969 2.794 2.794-1.414 1.414-2.794-2.794-1.586 1.586 1.794 1.794-1.414 1.414-1.794-1.794-1.792 1.794-1.414-1.414 9.176-9.177a5.5 5.5 0 01.642-7.005zm6.364 1.414a3.5 3.5 0 10-4.95 4.95 3.5 3.5 0 004.95-4.95z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};